export const afterExitColor = 'rgb(18, 78, 120)'
export const windowStartColor = 'rgb(252, 35, 94)'
export const windowEndColor = 'rgb(96, 173, 66)'
